export default function validationAffectationTfs(response, messages) {
  if (!response.data.error || !response.data.error.validationErrors) {
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('NOT_SAME_WEEK') === 0) {
      messages.push({ message: 'chargeTravailAff.popUpAffecter.messages.errors.sameWeek' });
    }
    if (message.indexOf('STATE_SHOULD_NOT_BE_CLOSED') === 0
      || message.indexOf('STATE_SHOULD_BE_SAVE') === 0) {
      messages.push({ message: 'chargeTravailAff.popUpAffecter.messages.errors.otSave' });
    }
  });
}
